(function IIFE() {
    'use strict';

    /////////////////////////////

    function UserSettingsFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/user/settings/:methodKey', {}, {
            save: {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'save',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('UserSettingsFactory', UserSettingsFactory);
})();
